import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { DeliveryStatus } from 'src/app/shared/enums';
import { OrderDetails, Tariff, ServiceProviderResponseModel, AuthModel } from 'src/app/shared/models';
import { OrderConfirmation } from 'src/app/shared/models/order-confirmation.model';
import { Price } from 'src/app/shared/models/price.model';
import { ProductModel } from 'src/app/shared/models/product.model';
import { PaymentService, FeedbackService } from 'src/app/shared/services';
import { UserService } from 'src/app/shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { StatusData } from '../../../shared/models/status-data.model';

@Component({
  selector: 'app-track-order',
  templateUrl: './track-order.component.html',
  styleUrls: ['./track-order.component.scss']
})
export class TrackOrderComponent implements OnInit {
  deliveryId: any;
  status: string;
  historyStatus: StatusData;
  loading: boolean;
  isReturning: boolean = false;
  translatePath = 'public.tracking.';
  orderConfirmation: OrderConfirmation | any;
  deliveryStatusEnum = DeliveryStatus;
  showMissingInfoMessage = false;
  orderDetails = {} as OrderDetails;
  option = {
    cost: 0
  } as Price;
  serviceProviderResponse = {} as ServiceProviderResponseModel;
  user: AuthModel;
  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private feedbackService: FeedbackService,
    private userService: UserService,
    public translateService: TranslateService
  ) { }

  getStatusText(status: DeliveryStatus) {
    switch (status) {
      case DeliveryStatus.AwaitingPayment: { return this.translatePath + 'awaiting-payment'; }
      case DeliveryStatus.Processing: { return this.translatePath + 'processing-order'; }
      case DeliveryStatus.Paid: { return this.translatePath + 'paid'; }
      case DeliveryStatus.AwaitingPickup: { return this.translatePath + 'awaiting-pickup'; }
      case DeliveryStatus.Ready: { return this.translatePath + 'ready'; }
      case DeliveryStatus.Cancelled: { return 'cancelled'; }
      case DeliveryStatus.Expired: { return 'expired'; }
      case DeliveryStatus.Delivering: { return this.translatePath + 'delivering'; }
      case DeliveryStatus.Delivered: { return this.translatePath + 'delivered'; }
      case DeliveryStatus.Confirmed: { return 'confirmed'; }
      case DeliveryStatus.Problem: { return 'problem'; }
      case DeliveryStatus.Returning: { return 'returning'; }
      case DeliveryStatus.Returned: { return 'returned'; }
      case DeliveryStatus.Unknown:
      default: {
        return '';
      }
    }
  }

  ngOnInit(): void {
    this.userService.isAutenticated$.subscribe(user => { this.user = user; });
    this.translateService.getLangs();
    this.deliveryId = this.route.snapshot.params.id;
    if (this.deliveryId) {
      this.loading = true;
      this.paymentService.getTrackingById(this.deliveryId)
        .pipe(
          finalize(
            () => { this.loading = false; }
          )
        )
        .subscribe(
          res => {
            this.orderConfirmation = res;
            this.status = this.getStatusText(this.orderConfirmation.status);
            this.isReturning = (this.status === 'problem' || this.status === 'returning' || this.status === 'returned');
            this.historyStatus = res.statuses.find(x => x.name === this.status && x.isActive === true) as StatusData;
            this.configureSummaryData();
          }, (err: HttpErrorResponse) => {
            this.feedbackService.handleError(err);
            this.showMissingInfoMessage = true;
          }
        );
    };
  }

  realDateOrder(data: any): string {
    const time = new Date(new Date(data).toUTCString());
    var timeZone = new Date().getHours() - new Date().getUTCHours();
    time.setHours(time.getHours() + (timeZone));
    return time.toString();
  }

  configureSummaryData() {
    this.orderDetails = {
      id: this.orderConfirmation.service.orderCode,
      price: this.orderConfirmation.products[0].price
    } as OrderDetails;
    this.option = {
      cost: this.orderConfirmation.cost
    } as Price;
    this.serviceProviderResponse = {
      products: this.orderConfirmation.products
    } as ServiceProviderResponseModel;
  }

  getEstimatedText() {
    return `${this.datePipe.transform(this.orderConfirmation.estimatedDeliveryStart, 'fullDate')}-${this.datePipe.transform(this.orderConfirmation.estimatedDeliveryEnd, 'fullDate')}`;
  }

  getPaymentDueText() {
    return `${this.datePipe.transform(this.orderConfirmation.paymentDueDate, 'dd/MM/yyyy')}`;
  }

  getDataTimeFromHistoryStatusesByHistoryName(historyName: string) {
    var data = this.orderConfirmation.historyStatuses.find((x: { name: string; }) => x.name === historyName)?.date;

    if (data === undefined || data === null) {
      return "";
    }
    else {
      return this.realDateOrder(data);
    }
  }

  getStatusFromStatusesByStatusName(statusName: string) {
    var status = this.orderConfirmation.statuses.find((x: { name: string; }) => x.name === statusName)?.isActive;

    if (status === undefined || status === null) {
      return false;
    }
    else {
      return status;
    }
  }
}
